var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classObject,on:{"click":_vm.purchase}},[_c('DescriptionDisplay',{attrs:{"config":_vm.config}}),(!_vm.isBought)?_c('CostDisplay',{attrs:{"config":_vm.config,"name":"Relic Shard","label":""}}):_c('div',[_vm._v(" (Unlocked) ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }